import { createClient } from 'contentful'
import { relevant } from '../../util'


export default function(){
    
    const initialState = {
        client: createClient({
            accessToken: process.env.REACT_APP_CONTENTFUL_COBRAND_ACCESS_TOKEN,
            space: process.env.REACT_APP_CONTENTFUL_COBRAND_SPACE,
            host: process.env.REACT_APP_CONTENTFUL_COBRAND_HOST,
            resolveLinks: true,
        }),
        
        loaded:false,
        loading:true,
    
        referenceId: null,
        footer: null,
        logoURL: null,
        products: null,
        url: null
    }
    

    return function(state = initialState, action){

        switch(action.type){

            //
            case "REQUEST_COBRAND": return {
                ...state,
                loaded:false,
                loading:true
            }

            //
            case "SUPPLY_COBRAND": return {
                ...state,
                loaded:true,
                loading:false,

                referenceId: action.data.referenceId,
                footer: action.data.footer,
                logoURL: action.data.logoURL,
                logoColouredURL: action.data.logoColouredURL,
                products: action.data.products,
                url: action.data.url,
            }

            //
            default: return state

        }

    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/cobrand/cobrand-reducer.ts